import { render } from "./edit-dialog.vue?vue&type=template&id=5b1a9df4&scoped=true&ts=true"
import script from "./edit-dialog.vue?vue&type=script&lang=ts"
export * from "./edit-dialog.vue?vue&type=script&lang=ts"

import "./edit-dialog.vue?vue&type=style&index=0&id=5b1a9df4&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1a9df4"]])

export default __exports__